import React from 'react';
import { Globe, Link as LinkIcon, Info } from 'lucide-react';
export function PublisherCard() {
  return <aside className="hidden lg:block w-full space-y-6 sticky top-6" data-id="element-1136">
      {/* Publisher Info Card */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-1137">
        <div className="p-5" data-id="element-1138">
          <div className="flex items-center gap-3 mb-4" data-id="element-1139">
            <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center text-white font-bold text-sm shrink-0" data-id="element-1140">
              BGR
            </div>
            <div data-id="element-1141">
              <h3 className="font-bold text-gray-900 text-lg leading-none" data-id="element-1142">
                BGR.com
              </h3>
            </div>
          </div>

          <div className="mb-4" data-id="element-1143">
            <p className="text-xs text-gray-500 uppercase font-semibold mb-1" data-id="element-1144">
              Website
            </p>
            <a href="#" className="flex items-center gap-1.5 text-blue-600 hover:underline text-sm font-medium" data-id="element-1145">
              <LinkIcon className="w-3.5 h-3.5" data-id="element-1146" />
              www.bgr.com
            </a>
          </div>

          <p className="text-sm text-gray-600 mb-6 leading-relaxed" data-id="element-1147">
            Your guide to the most interesting stories in tech, entertainment,
            lifestyle, science, and more.
          </p>

          <div className="grid grid-cols-2 gap-4 border-t border-gray-100 pt-4" data-id="element-1148">
            <div data-id="element-1149">
              <div className="text-lg font-bold text-gray-900" data-id="element-1150">4.1K</div>
              <div className="text-xs text-gray-500 font-medium" data-id="element-1151">Posts</div>
            </div>
            <div data-id="element-1152">
              <div className="text-lg font-bold text-gray-900" data-id="element-1153">407.4K</div>
              <div className="text-xs text-gray-500 font-medium" data-id="element-1154">Followers</div>
            </div>
          </div>
        </div>

        <div className="bg-gray-50 px-5 py-3 border-t border-gray-100 flex justify-between items-center" data-id="element-1155">
          <button className="text-sm font-medium text-blue-600 hover:text-blue-700" data-id="element-1156">
            Follow
          </button>
        </div>
      </div>

      {/* Ad Placeholder */}
      <div className="flex justify-end" data-id="element-1157">
        <span className="text-[10px] text-gray-400 border border-gray-200 px-1 rounded" data-id="element-1158">
          Ad
        </span>
      </div>

      {/* Transparency Note */}
      <div className="bg-gray-50 rounded-xl p-5 border border-gray-200" data-id="element-1159">
        <p className="text-sm text-gray-600 mb-3" data-id="element-1160">
          It's essential to note our commitment to transparency:
        </p>
        <p className="text-xs text-gray-500 leading-relaxed" data-id="element-1161">
          Our{' '}
          <a href="#" className="underline decoration-gray-400 hover:text-gray-800" data-id="element-1162">
            Terms of Use
          </a>{' '}
          acknowledge that our services may not always be error-free, and our{' '}
          <a href="#" className="underline decoration-gray-400 hover:text-gray-800" data-id="element-1163">
            Community Standards
          </a>{' '}
          emphasize our discretion in enforcing policies. As a platform hosting
          over 100,000 pieces of content published daily, we cannot pre-vet
          content, but we strive to foster a dynamic environment for free
          expression.
        </p>
      </div>
    </aside>;
}